"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const utils_1 = require("../../Auth/utils");
const AuthContext_1 = require("../../Auth/AuthContext");
const OrderRequestsGrid_1 = __importDefault(require("../../components/OrderRequests/OrderRequestsGrid"));
const permissions_1 = require("../../types/permissions");
const OrderRequests = ({ match }) => {
    const { orderId } = match.params;
    const { user } = (0, AuthContext_1.useAuth)();
    return (0, utils_1.isAllowed)(user, [permissions_1.OrdersPermissions.MANAGE_ORDER_QUANTITIES]) ? (react_1.default.createElement("div", { className: 'w-full flex flex-col' },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Bestellung")),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Bestellung")),
            react_1.default.createElement("div", { className: "mt-4 flex md:mt-0 md:ml-4" })),
        react_1.default.createElement(OrderRequestsGrid_1.default, { orderId: orderId }))) : null;
};
exports.default = OrderRequests;
